module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch05.htm#map_78"
    }
  }, [_vm._v("1. The Western Front during 1917 and 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch08.htm#map_157"
    }
  }, [_vm._v("2. The Lille–Ghent sector in October 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch12.htm#map_222"
    }
  }, [_vm._v("3. The Intervention in Siberia, 1918–1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch12.htm#map_232"
    }
  }, [_vm._v("4. The Anti-Bolshevik forces in European Russia, 1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch16.htm#map_281"
    }
  }, [_vm._v("5. The Intervention in North Russia, 1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch16.htm#map_294"
    }
  }, [_vm._v("6. The Baltic, 1919–1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch18.htm#map_347"
    }
  }, [_vm._v("7. General Yudenitch’s advance, October 1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch19.htm#map_353"
    }
  }, [_vm._v("8. General Denikin’s defeat, October–December 1919")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch22.htm#map_394"
    }
  }, [_vm._v("9. The Russo-Polish war, 1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch26.htm#map_444"
    }
  }, [_vm._v("10. Ireland, 1919–1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch27.htm#map_474"
    }
  }, [_vm._v("11. Turkey, Persia and the Middle East, 1919–1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch30.htm#map_542"
    }
  }, [_vm._v("12. The Palestine Mandate, 1920–1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch45.htm#map_822"
    }
  }, [_vm._v("13. Constantinople and the Straits, 1921–1922")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492b2006","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/maps.vue
// module id = 75
// module chunks = 0